import { createCategoriesApi } from '@/v2/api/metadata/categories'
import { createSportsApi } from '@/v2/api/metadata/sports'
import { createTournamentRoundsApi } from '@/v2/api/metadata/tournament-rounds'
import { createTournamentsApi } from '@/v2/api/metadata/tournaments'
import type { BackofficeContext } from '@/v2/framework/context/types'
import type { EntityView } from '@/v2/framework/view/types'
import { columns, dynamicColumnSlots } from './columns'
import { createFilters } from './filters'
import { createDialogs } from './dialogs'

const LS_TOURNAMENT_ROUNDS_FILTERS_KEY = Symbol('tournament-rounds-filters')

export function createTournamentRoundsView(ctx: BackofficeContext): EntityView {
  const roundsApi = createTournamentRoundsApi(ctx)
  const sportsApi = createSportsApi(ctx)
  const categoriesApi = createCategoriesApi(ctx)
  const tournamentsApi = createTournamentsApi(ctx)

  return {
    id: 'tournament-rounds',
    view: [
      {
        type: 'grid',
        columns,
        filters: createFilters({ ctx, sportsApi, categoriesApi, tournamentsApi }),
        dynamicColumnSlots,
        dialogs: createDialogs({ ctx, roundsApi, sportsApi, categoriesApi, tournamentsApi }),
        syncRouteQuery: true,
        syncRouteDialog: true,
        hasExport: true,
        filtersKey: LS_TOURNAMENT_ROUNDS_FILTERS_KEY,
        allowSaveFilters: true,
        hasSearch: true,
        api: roundsApi.grid,
      },
    ],
  }
}
